import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "error-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.errorMessage), 1),
    _createVNode(_component_el_button, {
      type: "danger",
      plain: "",
      onClick: _ctx.onRetryPress
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode("Try again")
      ])),
      _: 1,
      __: [0]
    }, 8, ["onClick"])
  ]))
}